import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalletizer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 100,
	viewBox: "0 0 80.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 80,
			height: 100,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 5.0 60.0 L 75.0 60.0 M 75.0 80.0 L 20.0 80.0 M 15.0 60.0 L 15.0 30.0 L 40.0 30.0 L 40.0 35.0 L 65.0 35.0 L 65.0 60.0 M 15.0 55.0 L 65.0 55.0 M 15.0 50.0 L 65.0 50.0 M 15.0 45.0 L 65.0 45.0 M 15.0 40.0 L 65.0 40.0 M 15.0 35.0 L 40.0 35.0 M 27.5 35.0 L 27.5 40.0 M 27.5 45.0 L 27.5 50.0 M 27.5 55.0 L 27.5 60.0 M 40.0 40.0 L 40.0 45.0 M 40.0 50.0 L 40.0 55.0 M 52.5 35.0 L 52.5 40.0 M 52.5 45.0 L 52.5 50.0 M 52.5 55.0 L 52.5 60.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 20.0 77.0 L 20.0 83.0 L 9.0 80.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgPalletizer;
